// extracted by mini-css-extract-plugin
module.exports = {"fullReportModal":"FullReportModal_fullReportModal__1dfI2","isLoading":"FullReportModal_isLoading__Vgsxc","container":"FullReportModal_container__2SKIF"};